import { FC } from 'react';
import moment from 'moment'
import { Reason } from '../../models/supplier.model';
import './supplier-blocked-reasons.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  reasons : Reason[]
};

const SupplierBlockedReasons : FC<Props> = ({reasons}) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierBlockedReasons' });
  return <ul className="supplier-blocked-reasons">
    {reasons.map(reason => (
      <li key={reason._id || (''+reason.date)}>
        <div>{reason.reason}</div>
        <div className="supplier-blocked-reasons__event">
          {
            reason.adminName ?
              t('eventBy', 'Ändrad av {{name}}, {{timestamp}}', { context: reason.action, name: reason.adminName, timestamp: moment(reason.date).format('YYYY-MM-DD HH:mm') })
              : t('event', 'Ändrad, {{timestamp}}', { context: reason.action, timestamp: moment(reason.date).format('YYYY-MM-DD HH:mm') })
          }
        </div>
      </li>
    ))}
  </ul>;
};

export default SupplierBlockedReasons;
